import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { href: "/#services", label: "Services", id: "services" },
  { href: "/#process", label: "Process", id: "process" },
];

export const Nav = () => (
  <header className="fixed inset-x-0 top-0 z-40 border-b border-white/[0.06] bg-ink/70 backdrop-blur-xl">
    <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between px-5 md:h-20 md:px-10">
      <Logo />
      <nav className="hidden items-center gap-8 md:flex">
        {links.map((l) => (
          <a key={l.id} href={l.href} data-testid={`nav-${l.id}-link`} className="group relative text-sm text-slate-300 transition-colors hover:text-white">
            {l.label}
            <span className="absolute -bottom-1 left-0 h-px w-0 bg-ember transition-[width] duration-300 group-hover:w-full" />
          </a>
        ))}
        <Link to="/gaming-pc" data-testid="nav-gaming-link" className="text-sm text-slate-300 transition-colors hover:text-white">
          Gaming PCs
        </Link>
        <Link to="/track" data-testid="nav-track-link" className="text-sm text-slate-300 transition-colors hover:text-white">
          Track repair
        </Link>
      </nav>
      <div className="flex items-center gap-2">
        <Link to="/track" data-testid="nav-track-mobile-link" className="px-3 py-2 font-mono text-xs uppercase tracking-widest text-slate-300 md:hidden">
          Track
        </Link>
        <Link
          to="/request"
          data-testid="nav-request-repair-btn"
          className="group inline-flex items-center gap-2 whitespace-nowrap bg-ember px-3.5 py-2.5 text-sm font-semibold text-ink transition-[background-color,transform] duration-300 hover:bg-amber-400 active:scale-95 sm:px-4"
        >
          <span className="sm:hidden">Repair</span>
          <span className="hidden sm:inline">Request repair</span>
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
        </Link>
      </div>
    </div>
  </header>
);
